import { useQuery } from '@tanstack/react-query';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getExperiences } from '../api';
import { experiencesQueryKeys } from '../data';
import { useTablePagination } from '../store/use-table-pagination-store';
import { useExperienceFilterStore } from '../store';

export const useGetExperiences = () => {
  const search = useExperienceFilterStore((state) => state.search);
  const year = useExperienceFilterStore((state) => state.year);
  const rowsPerPage = useTablePagination((state) => state.rowsPerPage);

  return useInfiniteQuery({
    queryKey: [
      ...experiencesQueryKeys.getExperiences,
      { search, year, rowsPerPage },
    ],
    queryFn: ({ pageParam = 1 }) =>
      getExperiences({ search, year, page: pageParam, rowsPerPage }),
    getNextPageParam: (lastPage, allPages) => {
      const loadedCount = allPages.reduce(
        (sum, page) => sum + page.data.length,
        0
      );
      return loadedCount < lastPage.total ? allPages.length + 1 : undefined;
    },
    initialPageParam: 1,
    staleTime: 5000,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
};
